import { addDays, formatYmd, type ParentId, type Ymd } from './dates';

function foldLine(line: string): string {
  if (line.length <= 75) return line;
  const parts: string[] = [];
  let remaining = line;
  parts.push(remaining.slice(0, 75));
  remaining = remaining.slice(75);
  while (remaining.length) {
    parts.push(` ${remaining.slice(0, 74)}`);
    remaining = remaining.slice(74);
  }
  return parts.join('\r\n');
}

function escapeText(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
}

export type CalendarDay = {
  date: Ymd;
  parent: ParentId;
};

export function buildParentCalendar(
  days: CalendarDay[],
  names: { A: string; B: string },
  calendarName: string,
): string {
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//Harbor Satellites//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    foldLine(`X-WR-CALNAME:${escapeText(calendarName)}`),
  ];

  for (const day of days) {
    const start = formatYmd(day.date).replace(/-/g, '');
    const end = formatYmd(addDays(day.date, 1)).replace(/-/g, '');
    const summary = `${names[day.parent]} — parenting time`;
    const uid = `${start}-${day.parent}@${calendarName.replace(/\s+/g, '').toLowerCase()}`;
    lines.push(
      'BEGIN:VEVENT',
      `UID:${uid}`,
      `DTSTAMP:${start}T000000Z`,
      `DTSTART;VALUE=DATE:${start}`,
      `DTEND;VALUE=DATE:${end}`,
      foldLine(`SUMMARY:${escapeText(summary)}`),
      'END:VEVENT',
    );
  }

  lines.push('END:VCALENDAR', '');
  return lines.join('\r\n');
}

export function downloadIcs(filename: string, ics: string): void {
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
